<template>
  <SectionOffices
    :background="background"
    class="SectionContacts"
    :customQuery="{ type: { $in: ['PARDAVIMAI', 'Pardavimai'] } }"
    :doShowType="doShowOfficeType">
    <h2 slot="title" class="title">
      {{ title }}
    </h2>
  </SectionOffices>
</template>

<script>
import SectionOffices from './SectionOffices'

export default {
  components: { SectionOffices },
  props: {
    background: { type: String, default: 'grey' },
    doShowOfficeType: { type: Boolean, default: true },
    title: String,
  },
}
</script>

<style lang="scss">
#SectionOffices {
  .title {
    margin-bottom: 5rem;
  }

  .office-row {
    margin-top: 2rem;
  }

  &.grey {
    background-color: $grey-lightest;
  }
}
</style>
